"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.mapDispatchToProps = exports.mapStateToProps = void 0;
const react_redux_1 = require("react-redux");
const index_1 = __importDefault(require("./index"));
const app_1 = require("ducks/app");
const contact_infos_1 = require("ducks/contact-infos");
// ducks
const households_1 = require("ducks/households");
const profile_1 = require("ducks/profile");
// selectors
const households_2 = require("selectors/households");
const profile_2 = require("selectors/profile");
const user_1 = require("selectors/user");
const mapStateToProps = (state) => {
    const currentProfile = (0, profile_2.getCurrentProfile)(state);
    const user = (0, user_1.getUser)(state);
    return {
        households: (0, households_2.getHouseholds)(state),
        householdOwnedByUser: (0, households_2.householdOwnedByUser)(state, (0, profile_2.currentProfileUuid)(state)),
        householdsNotOwnedByUser: (0, households_2.householdsNotOwnedByUser)(state, (0, profile_2.currentProfileUuid)(state)),
        currentProfile,
        user,
        profileHasPerson: (0, profile_2.hasPerson)(currentProfile),
    };
};
exports.mapStateToProps = mapStateToProps;
exports.mapDispatchToProps = {
    submitHouseholdForm: households_1.submitHouseholdForm,
    deleteHouseholdPerson: households_1.deleteHouseholdPerson,
    resendInvite: households_1.resendInvite,
    deleteInvite: households_1.deleteInvite,
    setSelectedMember: households_1.setSelectedMember,
    loadContactInfos: contact_infos_1.loadContactInfos,
    submitProfileForm: profile_1.submitProfileForm,
    appFeedbackMessageError: app_1.appFeedbackMessageError,
};
exports.default = (0, react_redux_1.connect)(exports.mapStateToProps, exports.mapDispatchToProps)(index_1.default);
